import { useNavigate } from "react-router-dom";

//material-ui
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

//hooks
import { useAppSelector } from "../../hooks/reduxHooks";

//components
import DeviceSettings from "./DeviceSettings";

//helpers
import { timestampFormatDateTime } from "../../helpers/timestampFormat";

interface DeviceTableProps {
	Devices: Device[] | null;
	JobSummaries: JobSummary[] | null;
	refetch: () => void;
}

const DeviceTable = ({ Devices, JobSummaries, refetch }: DeviceTableProps) => {
	const FromDevices = useAppSelector((state) => state.device);
	const navigate = useNavigate();

	return (
		<TableContainer component={Paper}>
			<Table sx={{ minWidth: 650 }} aria-label="simple table">
				<TableHead>
					<TableRow>
						<TableCell>Counter</TableCell>
						<TableCell>Last Count</TableCell>
						<TableCell>Last Reported</TableCell>
						<TableCell>JobID</TableCell>
						<TableCell>Botanical</TableCell>
						<TableCell>Size</TableCell>
						<TableCell>Start Week</TableCell>
						<TableCell>Ready Week</TableCell>
						<TableCell>Started</TableCell>
						<TableCell>Settings</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{Devices?.map((Device) => {
						let DeviceID = Device.DeviceID;
						let JobSummary = JobSummaries?.find((j) => j.DeviceID === DeviceID);
						let FromDevice = FromDevices[DeviceID];
						if (!Device || !JobSummary) return null;
						JobSummary = JobSummary.Posted || JobSummary.Posted === null ? undefined : JobSummary;
						return (
							<TableRow key={Device.DeviceID} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
								<TableCell component="th" scope="row">
									<Button style={{ whiteSpace: "nowrap" }} variant="contained" onClick={() => navigate("/counter/" + DeviceID)}>
										{Device.Title}
									</Button>
								</TableCell>
								<TableCell>{isNaN(Number(FromDevice?.Quantity)) ? "" : FromDevice?.Quantity}</TableCell>
								<TableCell>{FromDevice?.DeviceTime ? timestampFormatDateTime(Number(FromDevice?.DeviceTime), 1000) : ""}</TableCell>
								<TableCell>{JobSummary?.JobID}</TableCell>
								<TableCell>{JobSummary?.Botanical}</TableCell>
								<TableCell>{JobSummary?.Size}</TableCell>
								<TableCell>{JobSummary?.StartWeek}</TableCell>
								<TableCell>{JobSummary?.ReadyWeek}</TableCell>
								<TableCell>{isNaN(Number(JobSummary?.CreateDate)) ? "" : timestampFormatDateTime(Number(JobSummary?.CreateDate))}</TableCell>
								<TableCell>
									<DeviceSettings Device={Device} refetch={refetch} />
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default DeviceTable;
